module.exports = __webpack_public_path__ + "static/media/world-of-mediation.5f8a6d0b.png";